import { render, staticRenderFns } from "./statisticsHeader.vue?vue&type=template&id=0afe42b5&scoped=true&"
import script from "./statisticsHeader.vue?vue&type=script&lang=js&"
export * from "./statisticsHeader.vue?vue&type=script&lang=js&"
import style0 from "./statisticsHeader.vue?vue&type=style&index=0&id=0afe42b5&prod&lang=scss&scoped=true&"
import style1 from "./statisticsHeader.vue?vue&type=style&index=1&id=0afe42b5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afe42b5",
  null
  
)

export default component.exports